let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3dJ8F")).then(() => parcelRequire('h6Ff1'));